/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import VueRouter from 'vue-router'
import { Form, HasError, AlertError } from "vform";
import VueProgressBar from "vue-progressbar";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import VueExcelXlsx from "vue-excel-xlsx";

Vue.use(VueRouter)
Vue.use(VueExcelXlsx);
window.Form = Form;
window.Swal = Swal;
window.Fire = new Vue();
window.Multiselect = Multiselect;
Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);

//Vue paginnation
Vue.component('pagination', require('laravel-vue-pagination'));

//for progessbar
Vue.use(VueProgressBar, {
    color: "rgb(0, 255, 140)",
    failedColor: "red",
    thickness: "7px",
});
// /Global function for currency formate
Vue.prototype.currencyFormate = (data) => {
    return new Intl.NumberFormat('en-IN', { currency: 'IND' }).format(data)
}
// Global Function for date formate
Vue.prototype.customDateFormatter = (date) => {
    let tempDate = moment(date).format("DD-MM-YYYY hh:mm");
    if(tempDate != 'Invalid date'){ return tempDate } else { return 'NULL' }
}


Vue.prototype.$PaginationCounterLimit = 2;
Vue.prototype.$PaginationLimit = '10';
Vue.prototype.$PaginationOptions = ['1','10','50','100','500','1000'];

//sweet alert
const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
    onOpen: toast => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
    }
});

window.Toast = Toast;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
Vue.component(
    "ToastTemplet",
    require("./components/widget/toast.vue").default
);

let routes = [
    { path: '/Home', component: require('./components/Dashboard.vue').default },
    { path: '/ManageBank', component: require('./components/ManageBank/ManageBank.vue').default },
    { path: '/ManageBankBranch', component: require('./components/ManageBankBranch/ManageBankBranch.vue').default },
    { path: '/ManageProduct', component: require('./components/ManageProduct/ManageProduct.vue').default },
    { path: '/ManageEmployee', component: require('./components/ManageEmployee/ManageEmployee.vue').default },
    { path: '/ViewClient',name:'ViewClient', component: require('./components/ManageClient/ViewClient.vue').default },
    { path: '/AllocatedClientList',name:'AllocatedClientList', component: require('./components/ManageClient/AllocatedClientList.vue').default },
    { path: '/OverAllCaseClientList',name:'OverAllCaseClientList', component: require('./components/ManageClient/OverAllCaseClientList.vue').default },
    { path: '/CompletedAllCaseClientList',name:'CompletedAllCaseClientList', component: require('./components/ManageClient/CompletedAllCaseClientList.vue').default },
    { path: '/ImportClientExcel', component: require('./components/ManageClient/ImportClientExcel.vue').default },
    { path: '/AddBCPList', component: require('./components/ManageClient/AddBCPList.vue').default },
    { path: '/AllocationList',name:'AllocationList', component: require('./components/ManageClient/AllocationList.vue').default },
    { path: '/TrashBank', component: require('./components/Trash/TrashBank.vue').default },
    { path: '/TrashBankBranch', component: require('./components/Trash/TrashBankBranch').default },
    { path: '/TrashProduct', component: require('./components/Trash/TrashProduct.vue').default },
    { path: '/TrashEmployee', component: require('./components/Trash/TrashEmployee.vue').default },
    { path: '/TrashClient', component: require('./components/Trash/TrashClient.vue').default },
    { path: '/TrashAdmin', component: require('./components/Trash/TrashAdmin.vue').default },
    { path: '/Employee', component: require('./components/ExampleComponent.vue').default },
    { path: '/ManageAdmin', component: require('./components/ManageAdmin/ManageAdmin.vue').default},
    { path: '/ClientInfo',name:'ClientInfo', component: require('./components/ManageClient/ClientInfo.vue').default}
  ];

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// register Route
const router = new VueRouter({
    mode:"history", // short for `routes: routes`
    routes
  })

const app = new Vue({
    el: '#app',
    router
});

